import totalCartPriceBeforeTax from './totalCartPriceBeforeTax';
import numeral from 'numeral';

const formattedTotalCartPriceBeforeTax = (products, combos) =>
  numeral(totalCartPriceBeforeTax(products, combos)).format('$0.00');

export default formattedTotalCartPriceBeforeTax;
